import { useEffect, useState } from "react";
import { FormattedMessage as FM } from "react-intl";
import { XMarkIcon, NoteIcon } from "components/Icons";

import Attachment from "components/Attachment/Attachment";
import IconButton from "components/Buttons/IconButton";
import MenuReport from "components/MeForm/MenuReport";
import MenuWizard from "components/MeForm/MenuWizard";
import NotesModalContent from "components/Meta/NotesModalContent";
import { useNotesModal } from "components/Meta/notesModalStore";
import proxy from "api/proxy";

import {
  saveIcon,
  attachmentIcon,
  deleteIcon,
} from "components/MeForm/iconForm";
import mainStore from "store/mainStore";
import { classNames, cn } from "tools/ui";

const colspan = "md:col-span-2 lg:col-span-2 xl:col-span-2";
const styleHead =
  "flex justify-center items-center py-2 w-full px-3 lg:px-4 lg:pt-1.5 md:col-span-2 lg:col-span-2 xl:col-span-2";

function HeadForm({
  title,
  onClose,
  onSave,
  ctxView,
  kind,
  onChangeView,
  record,
  titleSize,
  showBackButton,
}) {
  const { store } = mainStore.getState();
  const [viewAttach, setViewAttach] = useState(false);
  const [notes, setNotes] = useState(null);
  const { model, form_action, access } = ctxView;

  useEffect(() => {
    let active = true;
    if (!ctxView.note || !record?.id || record.id < 0) return;
    proxy
      .search(
        "ir.note",
        [["resource", "=", `${model},${record.id}`]],
        ["id", "message", "create_date", "create_uid.rec_name", "unread"],
        null,
        [["create_date", "DESC"]],
      )
      .then(({ data }) => {
        if (active) setNotes(data ?? []);
      });
    return () => {
      active = false;
    };
  }, [ctxView.note, model, record?.id]);
  let btnAttachment;
  let btnDelete;
  let btnSave;
  let btnReports;
  let btnWizards;
  if (form_action) {
    btnAttachment = form_action.includes("attachment");
    let accessDelete = true;
    if (access && access.delete) {
      // must return true or false depends of the record evaluation
      accessDelete = access.delete(record);
    }
    if (accessDelete) {
      btnDelete = form_action.includes("delete");
    }
    // if (record.id > 0) {
    //   btnSave = form_action.includes("edit");
    // }
    /***the save button is necessary when the user is filling out the form
     *  and wants to save the form so as not to lose all the information,
     * e.g., shipment internal  */
    let accessEdit = true;
    if (access && access.edit) {
      // must return true or false depends of the record evaluation
      accessEdit = access.edit(record);
    }
    if (accessEdit) {
      btnSave = form_action.includes("edit");
    }
    btnReports = ctxView.reports;
    btnWizards = ctxView.wizards;
  }
  // FIXME: Add report if exists change to true trigger generate
  // const report = false;

  let bgColor = "";
  if (kind === "modal") {
    bgColor = "bg-slate-200";
  }

  const titleModel = model;
  let titleValue = "";
  if (title && title.field) {
    const nameField_ = `${title.field}.`;
    if (record[nameField_]) {
      titleValue = record[nameField_];
    } else {
      titleValue = record[title.field];
    }
    if (titleValue instanceof Object) {
      titleValue = titleValue.rec_name;
    }
  }

  function onAttachment() {
    setViewAttach(true);
  }

  function onDelete() {
    onSave("delete", [record]);
  }

  const notesList = record?.["notes."] ?? notes ?? [];
  const hasUnreadNotes =
    notesList.some((note) => note.unread === true) ?? false;

  function openNotifications() {
    if (!record?.id || record.id < 0) return;
    const rec = record["notes."]
      ? record
      : { ...record, "notes.": notes ?? [] };
    useNotesModal.getState().openModal(rec, null, `${model}.notifications`);
  }

  const toolbar = btnSave || btnAttachment || btnReports || btnDelete;

  const titleSizeClass = titleSize || "tablet:text-2xl md:text-4xl font-ligh";

  return (
    <div id="head-form" className={classNames(styleHead, bgColor)}>
      <h1 className={classNames("text-zinc-500", titleSizeClass, colspan)}>
        {titleModel && (
          <span className="font-light">
            {titleModel && <FM id={titleModel} />}
          </span>
        )}

        {titleValue && (
          <>
            <span> | </span>
            <span className="text-gray-700 font-bold">{titleValue}</span>
          </>
        )}
      </h1>
      <div className="flex ml-auto my-auto gap-2 space-x-6" id="actions_modal">
        {toolbar && (
          <div className="flex ml-auto my-auto rounded-md px-6 space-x-6">
            {saveIcon(btnSave, onSave)}
            {attachmentIcon(btnAttachment, onAttachment)}
            {deleteIcon(btnDelete, onDelete)}
            {btnReports && (
              <MenuReport ctxView={ctxView} activeRecord={record} />
            )}
            {btnWizards && (
              <MenuWizard ctxView={ctxView} activeRecord={record} />
            )}
          </div>
        )}
        {ctxView.note && (
          <button
            onClick={openNotifications}
            className="my-auto relative"
            aria-label="notifications"
          >
            <NoteIcon
              className={cn(
                "h-6 w-6 fill-current",
                hasUnreadNotes
                  ? "text-amber-500"
                  : "text-gray-600 hover:text-gray-600",
              )}
            />
            {notesList.length > 0 && (
              <span
                className={cn(
                  "absolute -top-1 -right-1 flex text-gray-600 h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-semibold",
                  hasUnreadNotes ? "bg-amber-500" : "bg-amber-400",
                )}
              >
                {notesList.length}
              </span>
            )}
          </button>
        )}
        {kind === "modal" ? (
          <XMarkIcon
            onClick={onClose}
            className="h-8 w-8 fill-zinc-600 stroke-2 cursor-pointer hover:fill-rose-700 my-auto"
            aria-hidden="true"
          />
        ) : (
          showBackButton !== false && (
            <IconButton
              onClick={(e) =>
                onChangeView(e, "return", mainStore.getState().store)
              }
              color="lime"
              name="button_back"
              tooltip="board.button_back"
            />
          )
        )}
      </div>
      {viewAttach && (
        <Attachment
          activeRecord={record}
          onClose={() => {
            setViewAttach(false);
          }}
          ctxView={ctxView}
          open={viewAttach}
        />
      )}
      {ctxView.note && <NotesModalContent />}
    </div>
  );
}

export default HeadForm;
